<template>
  <div class="confirm-renewal">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineRenewal.title')"
      :visible.sync="dialogRenew"
      width="40%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div style="display: flex; justify-content: center">
        <el-image
          style="width: 200px; height: 200px"
          :src="confirmRenew.img"
          :preview-src-list="srcList"
          fit="contain"
        ></el-image>
      </div>
      <el-form ref="confirmRecharge" :label-position="labelPosition" :model="renew" :rules="rules" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('confirmRecharge.isRenew')">
              <el-select
                v-model="renew.state"
                :no-data-text="$t('common.noData')"
                :no-match-text="$t('common.noData')"
                :placeholder="$t('confirmRecharge.pIsRenew')"
              >
                <el-option :label="$t('confirmRecharge.yes')" :value="1"></el-option>
                <el-option :label="$t('confirmRecharge.no')" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('confirmRecharge.password')" prop="password" :error="error.password">
              <el-input
                type="password"
                v-model="renew.password"
                :placeholder="$t('confirmRecharge.pPassword')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('confirmRecharge.refuse')"
              v-if="renew.state == 0"
              :prop="renew.state == 0 ? 'failure' : ''"
            >
              <el-input type="textarea" :rows="4" v-model="renew.failure"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="submitForm('confirmRecharge')">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "ConfirmRecharge",
    props: {
      dialogRenew: Boolean,
      confirmRenew: Object
    },
    data() {
      return {
        srcList: [],
        renew: {
          id: "",
          state: 0,
          failure: "",
          password: ""
        },
        labelPosition: "top",
        rules: {
          failure: [
            {
              required: true,
              message: this.$t("confirmRecharge.pRefuse"),
              trigger: "blur"
            }
          ],
          password: [
            {
              required: true,
              message: this.$t("confirmRecharge.pPassword"),
              trigger: "blur"
            }
          ]
        },
        error: {
          password: ""
        }
      };
    },
    methods: {
      closeDialog() {
        this.cancel("");
      },
      openDialog() {
        this.srcList = [];
        this.srcList.push(this.confirmRenew.img);
      },
      cancel(state) {
        this.$emit("cancel", false, state);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let text = this.$t("rechargeRecord.renewCf");
            if (this.renew.state === 0) {
              text = this.$t("rechargeRecord.refuse");
            }
            this.$confirm(text, this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            }).then(() => {
              let obj = {};
              obj.id = this.confirmRenew.id;
              obj.state = parseInt(this.renew.state);
              obj.fail = this.renew.failure;
              obj.passWord = this.$md5(this.renew.password);
              this.$api.request(this.$url.RechargeRecord.confirm, this.$method.post, obj).then(res => {
                if (res.code === 0) {
                  if (parseInt(this.renew.state) == 1) {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: this.$t("rechargeRecord.success"),
                      type: "success"
                    });
                  } else if (parseInt(this.renew.state) == 0) {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: this.$t("rechargeRecord.error"),
                      type: "success"
                    });
                  }
                  this.cancel("up");
                } else {
                  this.$message.warning(this.$t(res.msg));
                }
              });
            });
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .confirm-renewal {
    .el-image {
      display: block;
      margin: 0 auto 20px;
      border-radius: 4px;
    }
  }
</style>
